import { api } from '@here/api'

export const getProfilePicture = async (id?: string): Promise<string | undefined> => {
	if (!id) return

	const extensions = ['png', 'jpg']
	const expiresIn = 60 * 60 * 24 * 7 // 7 days in seconds

	for (const ext of extensions) {
		const { data, error } = await api()
			.storage.from('profile-images')
			.createSignedUrl(`${id}.${ext}`, expiresIn)

		if (!error && data?.signedUrl) {
			return data.signedUrl
		}
	}

	return undefined
}
